module.exports = __webpack_public_path__ + "static/img/item18.000dfdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/item18.png
// module id = ICPb
// module chunks = 1